import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AspPaymentlistService } from './asp-paymentlist.service';
import { ToastrService } from 'ngx-toastr'; // Import ToastrService
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { AspLoadingService } from '../asp-loading/asp-loading.service';

@Component({
  selector: 'app-asp-paymentlist',
  templateUrl: './asp-paymentlist.component.html',
  styleUrls: ['./asp-paymentlist.component.scss']
})
export class AspPaymentlistComponent implements OnInit {
  payments: any[] = [];
  filteredPayments: any[] = [];
  isSidebarVisible: boolean = false;
  paymentLinkCreated: boolean = false;
  loading: boolean = false;  // Track the loading state
  showCancelConfirmation: boolean = false;
  selectedPayment: any;
  showCancelSuccess: boolean = false;
  createdPaymentLink: any;
  isCopied: boolean = false;
  successIcon: string;
  searchText: any = '';
  createdPaymentLinkId: any;
  date: string;
  paidAmount: string;
  status: string;
  garageKey: string;
  userId: string;
  lastSelectedStatus: string = 'All'; // Keep track of the last selected status

  // Initialize newPayment object to avoid undefined errors
  newPayment: any = {
    contactName: '',
    paymentFor: '',
    amount: '',
    paidAmount: '',
    linkId: '',
    status: '',
    date: '',
    mobile: ''
  };
  linkId: any;
  createdPaymentLink1: any;
  newPayments: FormGroup;
  newPayments1: FormGroup;

  // Inject ToastrService into the constructor
  constructor(
    private aspPaymentlistService: AspPaymentlistService,
    private toastr: ToastrService , // Inject ToastrService
    private _formBuilder: FormBuilder,
    private aspLoadingService: AspLoadingService,
  ) {}

  ngOnInit(): void {
    this.successIcon = '../../../../assets/icons/icons8-ok.gif';
    this.fetchStoredPayments(this.lastSelectedStatus);
  
    this.newPayments1 = this._formBuilder.group({
      contactName: ['', [Validators.required]],
      mobile: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      amount: ['', [Validators.required, Validators.pattern(/^[0-9]+$/)]], // Corrected pattern for amount
      paymentFor: ['']
    });
  }
  get ld() {
    return this.newPayments1.controls;
  }

  // Fetch stored payments with the selected status filter
  fetchStoredPayments(status: string = 'All'): void {
    this.aspLoadingService.show();
    const garageKey = localStorage.getItem('garageKey');
    const userId = localStorage.getItem('spareUserKey');

    this.aspPaymentlistService.storeUserDetails(garageKey, this.searchText, status, userId).subscribe(
      (response) => {
        if (response && response.code === 200) {
          this.aspLoadingService.hide();
          this.payments = response.data.payments;
          this.createdPaymentLink1=response.data.payments.paymentLink;
          this.payments.sort((a, b) => Number(b.paymentId) - Number(a.paymentId));
          this.filteredPayments = [...this.payments];
        } else {
          this.aspLoadingService.hide();
          this.toastr.error('Failed to fetch payments', 'Error');
          this.payments = [];
        }
      },
      (error: HttpErrorResponse) => {
        this.toastr.error('Failed to fetch payments', 'Error');
        this.payments = [];
      }
    );
  }

  filterPayments(status: string): void {
    // Check if the clicked status is the same as the last selected
    if (this.lastSelectedStatus === status) {
      
      this.lastSelectedStatus = 'All';
      this.fetchStoredPayments('All');
    } else {
      // Otherwise, apply the selected status filter
      this.lastSelectedStatus = status;
      this.fetchStoredPayments(status);
    }
  }

  isInputVisible: boolean = false; // Flag to control input visibility

  toggleSearch(): void {
    // Toggle the visibility of the search input
    this.isInputVisible = !this.isInputVisible;

    // Automatically focus the input if it becomes visible
    if (this.isInputVisible) {
      setTimeout(() => {
        const inputElement = document.querySelector('.SearchInput') as HTMLInputElement;
        if (inputElement) {
          inputElement.focus(); // Focus on the input when visible
        }
      }, 0);
    }
  }

  clearSearch(event: Event): void {
    event.stopPropagation();
    this.searchText = ''; // Reset search text
    this.isInputVisible = false; // Hide the input field and show the placeholder again
    this.fetchStoredPayments(this.lastSelectedStatus); // Reload the full list based on the last status filter
  }


  submitPayment(formData: any): void {
    // console.log("formData:", formData);
  
    if (this.newPayments1.invalid) {
      this.newPayments1.markAllAsTouched();
      this.toastr.error("Please Fill the Required Feilds"); // Show errors
      return;
    }
  
    if (this.loading) {
      return;
    }
  
    this.loading = true;
  
    const garageKey = localStorage.getItem('garageKey');
    const userId = localStorage.getItem('spareUserKey');
  
    if (!garageKey || !userId) {
      this.toastr.error('Garage Key or User ID is missing', 'Error');
      this.loading = false;
      return;
    }
  
    // Correctly map values from the form
    const { contactName, mobile, amount, paymentFor } = formData;
    // console.log("contactName:", contactName);
    // console.log("mobile:", mobile);
    // console.log("amount:", amount);
    // console.log("paymentFor:", paymentFor);
  
    // API Call to Create Payment Link
    this.aspPaymentlistService
      .getUserDetails(contactName, amount, garageKey, mobile, paymentFor, userId)
      .subscribe(
        (response) => {
          // console.log("response:", response);
          if (response && response.data) {
            this.newPayment.linkId = response.data.id;
            this.newPayment.status = 'Pending';
            this.newPayment.date = new Date().toISOString();
            this.newPayment.paidAmount = '0';
  
            this.createdPaymentLinkId = response.data.id;
            this.createdPaymentLink = response.data.paymentLink;
  
            // console.log("createdPaymentLink:", this.createdPaymentLink);
            this.payments.unshift({ ...this.newPayment });
            this.payments.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
            this.filteredPayments = [...this.payments];
            this.paymentLinkCreated = true;
  
            this.toastr.success('Payment link created successfully', 'Success');
            this.closeSidebar();
            this.clearNewPayment();
            this.newPayments1.reset();
          } else {
            this.toastr.error('Failed to create payment link', 'Error');
          }
        },
        (error) => {
          console.error('Error creating payment link:', error);
          this.toastr.error('Failed to create payment link', 'Error');
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  cancelPayment(payment: any): void {
    const garageKey = localStorage.getItem('garageKey');
    const userId = localStorage.getItem('spareUserKey');

    this.aspPaymentlistService.cancelUserDetails(garageKey, payment.paymentId, userId).subscribe(
      (response) => {
        this.showCancelConfirmation = false;

        if (response && response.code === 200) {
          payment.status = 'Cancelled';
          const index = this.payments.findIndex(p => p.linkId === payment.linkId);
          // console.log("payment.linkId----",payment.paymentId)
          if (index !== -1) {
            this.payments[index] = payment;
          }

          this.filteredPayments = [...this.payments];
          this.showCancelSuccess = true;
          this.toastr.success('Payment successfully cancelled', 'Success');
          this.fetchStoredPayments(this.lastSelectedStatus);
        } else {
          console.error('Failed to cancel payment:', response);
          // this.toastr.error('Cannot cancel or expire an already paid/partially paid link', 'Error');
        }
      },
      (error: HttpErrorResponse) => {
        console.error('Error cancelling payment:', error);
        // this.toastr.error('Failed to cancel payment due to server error', 'Error');
      }
    );
  }

  clearNewPayment(): void {
    this.newPayment = {
      contactName: '',
      paymentFor: '',
      amount: '',
      paidAmount: '',
      linkId: '',
      status: '',
      date: '',
      mobile: ''
    };
  }

  confirmCancelPayment(payment: any): void {
    this.selectedPayment = payment;
    this.showCancelConfirmation = true;
  }

  closeCancelPopup(): void {
    this.showCancelConfirmation = false;
  }

  closeSuccessPopup(): void {
    this.showCancelSuccess = false;
    this.paymentLinkCreated = false;
    this.fetchStoredPayments(this.lastSelectedStatus);
  }

  handleOutsideClick(event: Event): void {
    if (this.isSidebarVisible) {
      this.closeSidebar();
    }
  }

  openSidebar(): void {
    this.isSidebarVisible = true;
  }

  closeSidebar(): void {
    this.isSidebarVisible = false;
    this.newPayments1.reset();
    this.clearNewPayment();
  }

  shareOnWhatsApp(): void {
    if (!this.createdPaymentLink) {
      this.createdPaymentLink = this.generateRandomLink();
    }

    const message = `Hi Customer👋,\n\nThanks for choosing Ashish Garage for your repair needs!🙌\n\nPlease make the payment at your earliest convenience to initiate the repair process.\n\n💳Please find your payment link below:\n${this.createdPaymentLink}`;
    const url = `https://web.whatsapp.com/send?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
    this.toastr.success('The payment link has been shared on WhatsApp', 'Success');
  }

  generateRandomLink(): string {
    const randomId = Math.random().toString(36).substring(7);
    return `https://autoverse.com/payment/${randomId}`;
  }

  copyToClipboard(): void {
    if (this.createdPaymentLink) {
      navigator.clipboard.writeText(this.createdPaymentLink).then(() => {
        this.isCopied = true;
        this.toastr.success('Payment link copied to clipboard', 'Success');
        setTimeout(() => {
          this.isCopied = false;
        }, 2000);
      }).catch(err => {
        console.error('Failed to copy: ', err);
        this.toastr.error('Cannot cancel or expire an already paid/partially paid link', 'Error');
      });
    }
  }

  filterSuggestions(): void {
    const garageKey = localStorage.getItem('garageKey');
    const userId = localStorage.getItem('spareUserKey');

    if (!garageKey || !userId) {
      this.toastr.error('Garage Key or User ID is missing in localStorage.', 'Error');
      return;
    }

    this.aspPaymentlistService.storeUserDetails(garageKey, this.searchText, this.lastSelectedStatus, userId).subscribe(
      (response) => {
        if (response && response.code === 200) {
          this.filteredPayments = response.data.payments;
          this.payments.sort((a, b) => b.paymentId - a.paymentId);
          // this.filteredPayments = [...this.payments];
        } else {
          this.filteredPayments = [];
          console.error('Error retrieving filtered payments:', response);
          this.toastr.error('Error retrieving filtered payments', 'Error');
        }
      

      },
      (error: HttpErrorResponse) => {
        console.error('Error filtering payments:', error);
        this.toastr.error('Error filtering payments', 'Error');
        this.filteredPayments = [];
      }
    );
  }
}

